import { testId } from '../../utils';
import * as Labels from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

const LabelVariants = cva('font-normal', {
  variants: {
    variant: {
      default: 'text-gray-darkest',
      error: 'text-red',
    },
    size: {
      default: 'text-sm',
      lg: 'text-base',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
});

interface LabelTypes extends VariantProps<typeof LabelVariants> {
  children: React.ReactNode;
  className?: string;
  isError?: boolean;
  size?: 'default' | 'lg';
  'data-testid': string;
}

export const Label = ({
  children,
  size,
  className,
  isError,
  'data-testid': dataTestId,
}: LabelTypes) => {
  const variant = isError ? 'error' : 'default';

  return (
    <Labels.Root
      {...testId(dataTestId)}
      className={LabelVariants({ variant, size, className })}
    >
      {children}
    </Labels.Root>
  );
};
Label.displayName = 'Label';
